export default function industryResources() {
  if ($('.so-section-industry-resources .industry-resources').length) {
    $('.so-section-industry-resources .industry-resources').slick({
			arrows: true,
			dots: false,
      appendArrows: $('.so-section-industry-resources .industry-resources-arrows'),
			speed: 500,
			autoplay: true,
      autoplaySpeed: 5000,
			infinite: true,
			adaptiveHeight: true,
			mobileFirst: true,
			slidesToScroll: 1,
			slidesToShow: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
		});
  }
}